import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// index page sections
import Download from "../sub_components/Download.js";

import { MultiLang, Determinator } from "react-multi-language";
import Navbar from "components_/sub_components/Navbar.js";

class Innovations extends React.Component {
  state = {};
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
    console.log("..[log - Innovations.js (componentDidMount()), languageState] : ", this.props.languageState);
    console.log(this.props.languageState);
  };

  render() {
    return (
      <>
        <Navbar languageState={this.props.languageState} updateLanguageState={this.props.updateLanguageState} />
        {console.log("..[log - Innovations.js, languageState] : ", this.props.languageState)}
        {/* <DemoNavbar /> */}
        <main ref="main">
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="6">
                      <h1 className="display-3 text-white">
                        {/* Recent Activities{" "} */}
                        <Determinator>
                          {{
                            en: "Contact Us",
                            tw: "聯絡我們",
                            cn: "联络我们",
                          }}
                        </Determinator>
                        {" "}
                        {/* <span>completed with examples</span> */}
                      </h1>
                      {/* <button onClick={() => { this.props.updateLanguageState({ lang: "param" }) }}>road to success</button> */}
                      {/* <p className="lead text-white">
                        <Determinator>
                          {{
                            en: "Upcoming Events ",
                            tw: "近期活動",
                            cn: "近期活动",
                          }}
                        </Determinator>
                      </p> */}
                      {/* <div className="btn-wrapper">
                        <Button
                          className="btn-icon mb-3 mb-sm-0"
                          color="info"
                          href="https://demos.creative-tim.com/argon-design-system-react/#/documentation/alerts?ref=adsr-landing-page"
                        >
                          <span className="btn-inner--icon mr-1">
                            <i className="fa fa-code" />
                          </span>
                          <span className="btn-inner--text">Components</span>
                        </Button>
                        <Button
                          className="btn-white btn-icon mb-3 mb-sm-0 ml-1"
                          color="default"
                          href="https://www.creative-tim.com/product/argon-design-system-react?ref=adsr-landing-page"
                        >
                          <span className="btn-inner--icon mr-1">
                            <i className="ni ni-cloud-download-95" />
                          </span>
                          <span className="btn-inner--text">
                            Download React
                          </span>
                        </Button>
                      </div> */}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
                >
                  <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>

          <section className="section">
            <Container>

              <Card className="card-profile shadow mt--300">
                <div className="px-4">
                  <Row className="justify-content-center">
                    {/* <Col className="order-lg-2" lg="3">
                      <div className="card-profile-image">
                        <a href="#pablo" onClick={e => e.preventDefault()}>
                          <img
                            alt="..."
                            className="rounded-circle"
                            src={require("assets_/img_/activities/i360_202004_steel_bridge_view1_4096.jpg")}
                          />
                        </a>
                      </div>
                    </Col> */}
                    {/* <Col
                      className="order-lg-3 text-lg-right align-self-lg-center"
                      lg="4"
                    >
                      <div className="card-profile-actions py-4 mt-lg-0">
                        <Button
                          className="mr-4"
                          color="info"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                          size="sm"
                        >
                          Connect
                        </Button>
                        <Button
                          className="float-right"
                          color="default"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                          size="sm"
                        >
                          Message
                        </Button>
                      </div>
                    </Col> */}
                    {/* <Col className="order-lg-1" lg="4">
                      <div className="card-profile-stats d-flex justify-content-center">
                        <div>
                          <span className="heading">22</span>
                          <span className="description">Friends</span>
                        </div>
                        <div>
                          <span className="heading">10</span>
                          <span className="description">Photos</span>
                        </div>
                        <div>
                          <span className="heading">89</span>
                          <span className="description">Comments</span>
                        </div>
                      </div>
                    </Col> */}
                  </Row>
                  <div className="text-center mt-5">
                    {/* <h3>
                      Jessica Jones{" "}
                      <span className="font-weight-light">, 27</span>
                    </h3>
                    <div className="h6 font-weight-300">
                      <i className="ni location_pin mr-2" />
                      Bucharest, Romania
                    </div>
                    <div className="h6 mt-4">
                      <i className="ni business_briefcase-24 mr-2" />
                      Solution Manager - Creative Tim Officer
                    </div>
                    <div>
                      <i className="ni education_hat mr-2" />
                      University of Computer Science
                    </div> */}
                    <h3>
                      <Determinator>
                        {{
                          en: "Community Liaison Team",
                          tw: "社區聯絡小組",
                          cn: "社区联络小组",
                        }}
                      </Determinator>{" "}
                    </h3>
                    <p className="lead">
                      <br />
                      <Determinator>
                        {{
                          en: "Location: No. 21 Hang Tai Road, Ma On Shan",
                          tw: "地址: 馬鞍山恆泰路21號",
                          cn: "地址：马鞍山恒泰路21号",
                        }}
                      </Determinator>
                      <br />
                      <Determinator>
                        {{
                          en: "Telephone:     (852) 5220 0180",
                          tw: "聯絡電話：   (852) 5220 0180",
                          cn: "联络电话：   (852) 5220 0180",
                        }}
                      </Determinator>
                      <br />
                      <Determinator>
                        {{
                          en: "Fax: (852) 3914 5888",
                          tw: "傳真：（852）3914 5888",
                          cn: "传真：（852）3914 5888",
                        }}
                      </Determinator>
                      <br />
                      <Determinator>
                        {{
                          en: "E-mail: pr@stc-aecom.com",
                          tw: "電郵：pr@stc-aecom.com",
                          cn: "电邮：pr@stc-aecom.com",
                        }}
                      </Determinator>
                      <br />
                      <br />
                      <Determinator>
                        {{
                          en: "Office Hour (Mon to Fri, except for public holiday) :",
                          tw: "辦公時間（星期一至星期五，公眾假期除外）：",
                          cn: "办公时间（星期一至星期五，公众假期除外）：",
                        }}
                      </Determinator>
                      <br />
                      <Determinator>
                        {{
                          en: "09:00 am to 12:00 noon and ",
                          tw: "上午9時　至　中午12時　及",
                          cn: "上午9时　至　中午12时　及",
                        }}
                      </Determinator>
                      <br />
                      <Determinator>
                        {{
                          en: "1:00 pm to 6:00 pm ",
                          tw: "下午1時　至　下午6時",
                          cn: "下午1时　至　下午6时",
                        }}
                      </Determinator>
                    </p>
                  </div>
                  <div className="mt-5 py-5 border-top text-center">
                    <Row className="justify-content-center">
                      <Col lg="9">
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="facebook"
                          href="https://aecom-portal2.web.app/index"
                          id="tooltip837440414"
                          target="_blank"
                        >
                          <span className="btn-inner--icon">
                            <i className="fa fa-facebook-square" />
                          </span>
                        </Button>
                      </Col>
                    </Row>
                    <br />

                    <Row className="justify-content-center">
                      <Col lg="9">
                        {/* <p className="lead"> */}
                        <h15>
                          <Determinator>
                            {{
                              en: "Project Website: ",
                              tw: "項目網址：",
                              cn: "项目网址：",
                            }}
                          </Determinator>
                          <br />
                          <Determinator>
                            {{
                              en: "https://www.ststwincaverns.hk/",
                              tw: "https://www.ststwincaverns.hk/",
                              cn: "https://www.ststwincaverns.hk/",
                            }}
                          </Determinator>
                          <br />
                          <Determinator>
                            {{
                              en: "Stage 1 Contract Website: ",
                              tw: "第一階段工程網址：",
                              cn: "第一阶段工程网址：",
                            }}
                          </Determinator>
                          <br />
                          <Determinator>
                            {{
                              en: "https://www.ststwincavernss1.hk/",
                              tw: "https://www.ststwincavernss1.hk/",
                              cn: "https://www.ststwincavernss1.hk/",
                            }}
                          </Determinator>
                        </h15>
                        {/* </p> */}
                        {/* <a href="#pablo" onClick={e => e.preventDefault()}>
                          Show more
                        </a> */}
                      </Col>
                    </Row>
                  </div>
                </div>
              </Card>
            </Container>
          </section>


        </main>
        <MultiLang lang={this.props.languageState.lang} />

      </>
    );
  }
}

export default Innovations;
